<template>
    <div class="content-wrapper">
        <div class="card card-with-shadow border-0 mb-primary">
            <div class="card-header p-primary bg-transparent">
                <h5 class="card-title d-inline-block mb-0">{{$t('create_new_ticket')}}</h5>
                <!-- <div class="float-right">
                    <a href="/buyer/support" class="btn btn-primary">Back</a>
                </div> -->
            </div>
            <app-overlay-loader v-if="preloader"/>
            <div class="card-body">
                <form ref="form" data-url="" class="mb-0" :class="{'loading-opacity': preloader}">
                    <div class="form-group row align-items-center">
                        <label for="text_input" class="col-sm-2 mb-sm-0">
                            {{ $t('type') }}
                        </label>
                        <app-input id="text_input"
                                class="col-sm-8"
                                type="text"
                                v-model="inputs.text_input"
                                :placeholder="$t('text_type_input')"/>

                    </div>
                     <div class="form-group row align-items-center">
                        <label for="text_input" class="col-sm-2 mb-sm-0">
                            {{ $t('subject') }}
                        </label>
                        <app-input id="text_input"
                                class="col-sm-8"
                                type="text"
                                v-model="inputs.text_input"
                                :placeholder="$t('text_type_input')"/>

                    </div>
                    <div class="form-group row align-items-center">
                        <label for="textarea_field" class="col-sm-2 mb-sm-0">
                            {{ $t('message') }}
                        </label>
                        <app-input id="textarea_field"
                                class="col-sm-8"
                                type="textarea"
                                :placeholder="$t('textarea_field')"
                                v-model="inputs.textarea"/>
                    </div>
                    <div class="form-group mb-primary row align-items-center">
                        <label for="textarea_field" class="col-sm-2 mb-sm-0">
                            {{ $t('upload_document') }}
                        </label>
                        <div class="col-sm-8 default-file">
                            <app-input type="file"
                            :label="$t('upload_your_file')"
                            v-model="inputs.default_file"/>
                            <small class="text-muted font-italic">
                                {{ $t('recommended_default_file_validation') }}
                            </small>
                        </div>
                    </div>
                    <div class="mt-5 action-buttons">
                        <button type="submit" class="btn btn-primary mr-2" @click.prevent="submit">
                            {{ $t('submit') }}
                        </button>
                        <button type="submit" class="btn btn-secondary" @click.prevent="clear">
                            {{ $t('clear') }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import {FormMixin} from '../../../../../../core/mixins/form/FormMixin.js';
    import GlobalHelperMixin from '../../../../../Mixins/global/GlobalHelperMixin';
    export default {
        name: "InputFields",
        mixins: [FormMixin, GlobalHelperMixin],
        data() {
            return {
                preloader: false,
                inputs: {},
            }
        },
        methods: {
            beforeSubmit(){
                this.preloader = true;
            },
            submit() {
                this.scrollToTop(true);
                this.save(this.inputs);
            },
            afterFinalResponse() {
                this.preloader = false;
                this.scrollToTop(false);
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
                this.inputs = {};
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
            clear() {
                this.inputs = {};
                this.fieldStatus = {
                    isSubmit: false
                }
            },
        }
    }
</script>
